import React from 'react';

const LoadingSkeleton = ({ type = 'card', count = 3 }) => {
  const items = Array.from({ length: count });

  if (type === 'row') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {items.map((_, idx) => (
          <div key={idx} className="skeleton" style={{ height: '48px', width: '100%' }} />
        ))}
      </div>
    );
  }

  return (
    <div className="notes-grid">
      {items.map((_, idx) => (
        <div key={idx} className="card" style={{ padding: '20px', minHeight: '180px' }}>
          <div className="skeleton" style={{ height: '20px', width: '30%', marginBottom: '16px' }} />
          <div className="skeleton" style={{ height: '24px', width: '80%', marginBottom: '12px' }} />
          <div className="skeleton" style={{ height: '16px', width: '100%', marginBottom: '8px' }} />
          <div className="skeleton" style={{ height: '16px', width: '60%' }} />
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;
